import { Card } from "../../design-v2";

export default function SectionBlock({
  title,
  description,
  error,
  children,
  className = "",
}) {
  return (
    <Card tone="default" padding="md" className={`lz-settings-block ${className}`.trim()}>
      {title || description || error ? (
        <div className="mb-5">
          {title ? <h3 className="lz-settings-section__title">{title}</h3> : null}
          {description ? (
            <p className="lz-settings-section__description">{description}</p>
          ) : null}
          {error ? <p className="lz-settings-error">{error}</p> : null}
        </div>
      ) : null}

      <div className="space-y-6">{children}</div>
    </Card>
  );
}
